import { createContext, useContext } from 'react';

// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import type ProgramCurriculumProductsV1 from 'bundles/naptimejs/resources/programCurriculumProducts.v1';
import type { CourseDetails } from 'bundles/unified-home-common/providers/enterprise/EnterpriseEnrolledCourseProvider';

type EnterpriseEnrolledCourseContextType = {
  enrolledCourses?: ProgramCurriculumProductsV1[];
  inProgressCourse?: ProgramCurriculumProductsV1;
  inProgressCourseDetails?: CourseDetails;
  enrolledS12n?: ProgramCurriculumProductsV1;
  /**
   * If this is true, it means we should show the auto-enrolled s12n banner.
   */
  nextUpS12nCourseDetails?: CourseDetails;
};
const EnterpriseEnrolledCourseContext = createContext<EnterpriseEnrolledCourseContextType>({
  enrolledCourses: [],
  inProgressCourse: null,
  inProgressCourseDetails: undefined,
  enrolledS12n: null,
  nextUpS12nCourseDetails: undefined,
});

/**
 * @description This hook is used the get the user's currently enrolled courses and in-progress course
 */
export const useEnterpriseInProgressCourse = () => {
  const context = useContext(EnterpriseEnrolledCourseContext);

  return context;
};

export default EnterpriseEnrolledCourseContext;
